import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { safetyPolicy } from '../../data/policies/safety';
export function Safety() {
  return <PolicyFromText doc={safetyPolicy} data-id="element-1080" data-mp="10t2mdbcnamz7" />;
}